import { render } from "./ModalGroupLayout.vue?vue&type=template&id=0ba4dacc"
import script from "./ModalGroupLayout.vue?vue&type=script&lang=js"
export * from "./ModalGroupLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__